import { render, staticRenderFns } from "./cpt-num.vue?vue&type=template&id=32576be1&scoped=true"
import script from "./cpt-num.vue?vue&type=script&lang=js"
export * from "./cpt-num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32576be1",
  null
  
)

export default component.exports